import {Injectable, NgZone} from "@angular/core";
import {IonicErrorHandler} from "ionic-angular";
import {Response} from "@angular/http";
import {ToastService} from "./toast.service";
import {AppAuth} from "./auth";

@Injectable()
export class AppErrorHandler extends IonicErrorHandler {

  constructor(private toast: ToastService, private auth: AppAuth, private zone: NgZone) {
    super();
  }

  handleError(error: any): void {

    if (error.status === 401) {
      // Show login
      this.zone.run(() => this.auth.updateAuthStatus(false));

      if (this.shouldNotDisplayAuthenticationError(error)) {
        return;
      }
    }

    // Get error messages if http exception
    let msgs = [];
    if (error instanceof Response) {
      msgs = this.getMessagesFromResponse(error);
    } else {

      // Otherwise show generic error
      msgs.push('Something went wrong');
    }

    // Show messages
    msgs.forEach((msg) => {
      this.toast.show(msg);
    });

    // https://github.com/angular/angular/issues/8993
    super.handleError(error);
  }

  private shouldNotDisplayAuthenticationError(error) {
    let errorBody = error.json();
    if (!errorBody.hasOwnProperty('type')) {
      return false;
    }
    return errorBody.type === 'token_expired' || errorBody.type === 'token_not_provided' || errorBody.type === 'token_invalid';
  }

  private getMessagesFromResponse(response: Response) {
    var error;
    try {
      error = response.json();
    } catch (e) {
      error = {error: 'Something unexpected has happened :('};
    }

    var msgs = [];

    // If has a single error message
    if (typeof error.error !== 'undefined') {
      msgs.push(error.error);
    } else if (typeof error.message !== 'undefined') {
      msgs.push(error.message);
    } else if (response.status === 0) {
      msgs.push('Network error');
    } else {

      // Has field specific errors
      for (let field in error) {

        if (error.hasOwnProperty(field)) {
          if (error[field] instanceof String) {
            // Single error for field
            msgs.push(error);

          } else if (error[field] instanceof Array) {
            // Multiple errors for field
            error[field].forEach((msg) => {
              msgs.push(msg);
            });

          } else {
            // Something else
            msgs.push('Error!');
          }
        }
      }
    }
    return msgs;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/error-handler.ts